"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const DeveloperExportIcon = createIcon({
  displayName: "DeveloperExportIcon",
  viewBox: "0 0 45 45",
  path: (
    <>
      <path
        d="M22.5,45c-6.29,0-11.61-.97-15.97-2.91-4.35-1.94-6.53-4.3-6.53-7.09V10c0-2.75,2.2-5.1,6.59-7.06C10.99.98,16.29,0,22.5,0s11.51.98,15.91,2.94c4.4,1.96,6.59,4.31,6.59,7.06v25c0,2.79-2.18,5.16-6.53,7.09-4.35,1.94-9.68,2.91-15.97,2.91ZM22.5,15.06c3.71,0,7.44-.53,11.19-1.59,3.75-1.06,5.85-2.2,6.31-3.41-.46-1.21-2.55-2.35-6.28-3.44-3.73-1.08-7.47-1.62-11.22-1.62s-7.51.53-11.16,1.59c-3.65,1.06-5.76,2.22-6.34,3.47.58,1.25,2.7,2.4,6.34,3.44,3.65,1.04,7.36,1.56,11.16,1.56ZM22.5,27.5c1.75,0,3.44-.08,5.06-.25s3.18-.41,4.66-.72c1.48-.31,2.88-.7,4.19-1.16,1.31-.46,2.51-.98,3.59-1.56v-7.5c-1.08.58-2.28,1.1-3.59,1.56-1.31.46-2.71.84-4.19,1.16-1.48.31-3.03.55-4.66.72s-3.31.25-5.06.25-3.46-.08-5.12-.25-3.24-.41-4.72-.72c-1.48-.31-2.86-.7-4.16-1.16s-2.46-.98-3.5-1.56v7.5c1.04.58,2.21,1.1,3.5,1.56s2.68.84,4.16,1.16c1.48.31,3.05.55,4.72.72s3.38.25,5.12.25ZM22.5,40c1.92,0,3.86-.15,5.84-.44,1.98-.29,3.8-.68,5.47-1.16,1.67-.48,3.06-1.02,4.19-1.62,1.12-.6,1.79-1.22,2-1.84v-6.12c-1.08.58-2.28,1.1-3.59,1.56-1.31.46-2.71.84-4.19,1.16-1.48.31-3.03.55-4.66.72s-3.31.25-5.06.25-3.46-.08-5.12-.25-3.24-.41-4.72-.72c-1.48-.31-2.86-.7-4.16-1.16s-2.46-.98-3.5-1.56v6.19c.21.62.86,1.23,1.97,1.81s2.49,1.11,4.16,1.59c1.67.48,3.5.86,5.5,1.16s3.96.44,5.88.44Z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default DeveloperExportIcon;
